/**
 * Peers' rank + level on the social screens (specs/rank-on-social-screens).
 * Design: "Rank & Level Placement.dc.html" variant 1b · Shield Badge.
 */

/**
 * Max ids per batch request (AC-4). Mirrors XP_BATCH_MAX_USER_IDS in
 * server/src/constants/xp.constants.js — change both or the server 400s a request
 * the client believed was legal.
 */
export const XP_BATCH_MAX_USER_IDS = 100;

/** A peer's public standing. Deliberately NOT the full XpSummary — totals stay private (AC-3). */
export interface PlayerRank {
  /** Derived level 1..100. */
  level: number;
  /** Derived rank index 1..10 (Rookie … Icon). */
  rank: number;
}

/**
 * Friends-card crest geometry, as ratios of the avatar: its size scales with `cardWidth`
 * across the responsive grid, so fixed px would drift. From the design's 1b friends card
 * (62px crest offset -14/-12 on a 112px avatar).
 */
export const FRIEND_CARD_CREST_SIZE_RATIO = 0.55;
export const FRIEND_CARD_CREST_OFFSET_RATIO = 0.12;

export const PLAYER_RANK_TEST_IDS = {
  badge: 'player-rank-badge',
  levelPill: 'player-level-pill',
  /**
   * The friend card's profile chip. Not a rank element, but it is the one this feature
   * displaces (AC-7), and AC-14 turns on it NOT moving when there is no crest — so it needs
   * to be assertable.
   */
  friendCardProfileChip: 'friend-card-profile-chip',
} as const;
